(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const setupSochCartPage = (root) => {
    if (root.dataset.sdcpReady === 'true') return;
    root.dataset.sdcpReady = 'true';

    const form = root.querySelector('[data-sdcp-cart-form]');
    if (!form) return;

    const updateButton = root.querySelector('[data-sdcp-update]');
    const updateText = root.querySelector('[data-sdcp-update-text]');
    const status = root.querySelector('[data-sdcp-status]');
    const quantityInputs = () => [...root.querySelectorAll('[data-sdcp-quantity]')];
    const originalUpdateText = updateText?.textContent || '';

    const setBusy = (busy) => {
      root.classList.toggle('is-busy', busy);
      if (updateButton) updateButton.disabled = busy;
      root.querySelectorAll('[data-sdcp-delta], [data-sdcp-remove]').forEach((control) => {
        control.toggleAttribute('aria-disabled', busy);
      });
      if (updateText) updateText.textContent = busy ? root.dataset.updatingLabel : originalUpdateText;
    };

    const showError = (message) => {
      if (!status) return;
      status.textContent = message;
      status.classList.add('is-error');
    };

    const updateCart = async () => {
      if (root.classList.contains('is-busy')) return;
      const updates = {};
      quantityInputs().forEach((input) => {
        updates[input.dataset.lineKey] = Math.max(0, Number.parseInt(input.value, 10) || 0);
      });
      const note = form.querySelector('[name="note"]')?.value || '';
      setBusy(true);
      if (status) {
        status.textContent = '';
        status.classList.remove('is-error');
      }
      try {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootUrl}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates, note })
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || root.dataset.errorLabel);
        window.location.reload();
      } catch (error) {
        showError(error.message || root.dataset.errorLabel);
        setBusy(false);
      }
    };

    root.addEventListener('click', (event) => {
      const deltaButton = event.target.closest('[data-sdcp-delta]');
      if (deltaButton) {
        event.preventDefault();
        if (root.classList.contains('is-busy')) return;
        const line = deltaButton.closest('[data-sdcp-line]');
        const input = line?.querySelector('[data-sdcp-quantity]');
        if (!input) return;
        const delta = Number(deltaButton.dataset.sdcpDelta) || 0;
        input.value = Math.max(0, (Number.parseInt(input.value, 10) || 0) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const removeButton = event.target.closest('[data-sdcp-remove]');
      if (removeButton) {
        event.preventDefault();
        if (root.classList.contains('is-busy')) return;
        const line = removeButton.closest('[data-sdcp-line]');
        const input = line?.querySelector('[data-sdcp-quantity]');
        if (!input) return;
        input.value = 0;
        line.classList.add('is-removing');
        updateCart();
      }
    });

    root.addEventListener('change', (event) => {
      const input = event.target.closest('[data-sdcp-quantity]');
      if (!input) return;
      input.value = Math.max(0, Number.parseInt(input.value, 10) || 0);
      input.closest('[data-sdcp-line]')?.classList.toggle('is-removing', input.value === '0');
    });

    form.addEventListener('submit', (event) => {
      if (event.submitter?.name === 'checkout') return;
      event.preventDefault();
      updateCart();
    });
  };

  document.querySelectorAll('[data-sdcp-cart]').forEach(setupSochCartPage);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-sdcp-cart]').forEach(setupSochCartPage);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-engine"]) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'sochdost:wishlist:v1';
    const root = document.querySelector('[data-wishlist-engine]');
    if (!root || window.SochDostWishlist) return;

    const labels = {
      add: root.dataset.addLabel,
      remove: root.dataset.removeLabel,
      saved: root.dataset.savedLabel,
      select: root.dataset.selectLabel,
      cart: root.dataset.cartLabel,
      adding: root.dataset.addingLabel,
      added: root.dataset.addedLabel,
      error: root.dataset.errorLabel
    };

    const heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg>';

    const read = () => {
      try {
        const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(value) ? value.filter(item => item && item.handle) : [];
      } catch (_) {
        return [];
      }
    };

    const write = items => {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      sync();
      document.dispatchEvent(new CustomEvent('sochdost:wishlist-change', { detail: items }));
    };

    const has = handle => read().some(item => item.handle === handle);

    const toggle = item => {
      const items = read();
      const index = items.findIndex(entry => entry.handle === item.handle);
      if (index > -1) {
        items.splice(index, 1);
        toast(labels.remove);
      } else {
        items.unshift(item);
        toast(labels.saved);
      }
      write(items);
    };

    const toast = message => {
      const element = document.querySelector('[data-toast]');
      if (!element) return;
      element.textContent = message;
      element.classList.add('is-visible');
      window.clearTimeout(element._wishlistTimer);
      element._wishlistTimer = window.setTimeout(() => element.classList.remove('is-visible'), 2200);
    };

    const normalizeUrl = url => {
      try { return new URL(url, window.location.origin).pathname; }
      catch (_) { return url || ''; }
    };

    const handleFromUrl = url => {
      const match = normalizeUrl(url).match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    };

    const itemFromCard = card => {
      const link = card.querySelector('.sd-product-card__title, .sd-product-card__image-link');
      const image = card.querySelector('.sd-product-card__image--primary, .sd-product-card__image, img');
      const price = card.querySelector('.sd-price__current');
      const url = link ? normalizeUrl(link.getAttribute('href')) : '';
      return {
        handle: handleFromUrl(url),
        title: (card.querySelector('.sd-product-card__title')?.textContent || '').trim(),
        url,
        image: image?.currentSrc || image?.src || '',
        price: (price?.textContent || '').trim()
      };
    };

    const itemFromProduct = () => {
      const canonical = document.querySelector('link[rel="canonical"]')?.href || window.location.pathname;
      const image = document.querySelector('.sd-product-media img');
      return {
        handle: handleFromUrl(canonical),
        title: (document.querySelector('.sd-product__title')?.textContent || '').trim(),
        url: normalizeUrl(canonical),
        image: image?.currentSrc || image?.src || '',
        price: (document.querySelector('[data-product-price]')?.textContent || '').trim()
      };
    };

    const createButton = (item, productPage = false) => {
      if (!item.handle) return null;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = productPage ? 'sd-wishlist-toggle sd-product-wishlist' : 'sd-wishlist-toggle';
      button.dataset.wishlistHandle = item.handle;
      button.innerHTML = heart + (productPage ? '<span data-wishlist-label></span>' : '');
      const active = has(item.handle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? labels.remove : labels.add);
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = active ? labels.saved : labels.add;
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        toggle(item);
      });
      return button;
    };

    const enhanceCards = scope => {
      (scope || document).querySelectorAll('.sd-product-card').forEach(card => {
        if (card.dataset.wishlistReady === 'true') return;
        const media = card.querySelector('.sd-product-card__media');
        const item = itemFromCard(card);
        const button = createButton(item);
        if (!media || !button) return;
        media.appendChild(button);
        card.dataset.wishlistReady = 'true';
      });
    };

    const enhanceProduct = () => {
      const info = document.querySelector('.sd-product__info');
      if (!info || info.querySelector('.sd-product-wishlist')) return;
      const item = itemFromProduct();
      const button = createButton(item, true);
      if (!button) return;
      const anchor = info.querySelector('.sd-product__descriptor') || info.querySelector('.sd-product__tax-note');
      if (anchor) anchor.insertAdjacentElement('afterend', button);
      else info.prepend(button);
    };

    const syncHeader = items => {
      const link = document.querySelector('.sd-wishlist-button');
      if (!link) return;
      let count = link.querySelector('.sd-wishlist-count');
      if (!count) {
        count = document.createElement('span');
        count.className = 'sd-wishlist-count';
        count.setAttribute('aria-hidden', 'true');
        link.appendChild(count);
      }
      count.textContent = items.length;
      count.hidden = items.length === 0;
      link.setAttribute('aria-label', `Wishlist (${items.length})`);
    };

    const sync = () => {
      const items = read();
      document.querySelectorAll('[data-wishlist-handle]').forEach(button => {
        const active = items.some(item => item.handle === button.dataset.wishlistHandle);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.setAttribute('aria-label', active ? labels.remove : labels.add);
        const label = button.querySelector('[data-wishlist-label]');
        if (label) label.textContent = active ? labels.saved : labels.add;
      });
      syncHeader(items);
      renderPage(items);
    };

    const escapeHtml = value => String(value || '').replace(/[&<>"']/g, character => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
    })[character]);

    const renderPage = items => {
      const page = document.querySelector('[data-wishlist-page]');
      if (!page) return;
      const grid = page.querySelector('[data-wishlist-grid]');
      const empty = page.querySelector('[data-wishlist-empty]');
      const count = page.querySelector('[data-wishlist-page-count]');
      if (!grid || !empty) return;

      count.textContent = String(items.length).padStart(2, '0');
      empty.hidden = items.length > 0;
      grid.hidden = items.length === 0;
      grid.innerHTML = items.map(item => `
        <article class="sd-wishlist-card" data-wishlist-card="${escapeHtml(item.handle)}">
          <a class="sd-wishlist-card__media" href="${escapeHtml(item.url)}">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
            <span class="sd-wishlist-card__index">${String(items.indexOf(item) + 1).padStart(2, '0')}</span>
          </a>
          <div class="sd-wishlist-card__body">
            <div class="sd-wishlist-card__topline">${escapeHtml(page.dataset.savedPieceLabel)} <span>${escapeHtml(item.price)}</span></div>
            <a class="sd-wishlist-card__title" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
            <div class="sd-wishlist-card__variants" data-wishlist-variants></div>
            <div class="sd-wishlist-card__actions">
              <button class="sd-button sd-wishlist-card__cart" type="button" data-wishlist-cart disabled>${escapeHtml(labels.select)}</button>
              <button class="sd-wishlist-card__remove" type="button" data-wishlist-remove>${escapeHtml(labels.remove)}</button>
            </div>
          </div>
        </article>
      `).join('');

      grid.querySelectorAll('[data-wishlist-card]').forEach(card => hydrateCard(card, items));
    };

    const hydrateCard = async (card, items) => {
      const handle = card.dataset.wishlistCard;
      const item = items.find(entry => entry.handle === handle);
      const remove = card.querySelector('[data-wishlist-remove]');
      const cartButton = card.querySelector('[data-wishlist-cart]');
      const variantsRoot = card.querySelector('[data-wishlist-variants]');

      remove.addEventListener('click', () => toggle(item));

      try {
        const response = await fetch(`${item.url}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product unavailable');
        const product = await response.json();
        const variants = (product.variants || []).filter(variant => variant.available);
        if (!variants.length) {
          cartButton.textContent = pageLabel('soldOut', 'SOLD OUT');
          return;
        }

        let selected = variants.length === 1 ? variants[0] : null;
        if (variants.length > 1) {
          variantsRoot.innerHTML = variants.map(variant => `
            <button type="button" data-variant-id="${variant.id}">${escapeHtml(variant.title)}</button>
          `).join('');
          variantsRoot.querySelectorAll('button').forEach(button => {
            button.addEventListener('click', () => {
              variantsRoot.querySelectorAll('button').forEach(value => value.classList.remove('is-selected'));
              button.classList.add('is-selected');
              selected = variants.find(variant => String(variant.id) === button.dataset.variantId);
              cartButton.disabled = false;
              cartButton.textContent = labels.cart;
            });
          });
        } else {
          cartButton.disabled = false;
          cartButton.textContent = labels.cart;
        }

        cartButton.addEventListener('click', async () => {
          if (!selected) return;
          cartButton.disabled = true;
          cartButton.textContent = labels.adding;
          try {
            const addResponse = await fetch(window.SochDostRoutes?.cartAdd || '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: selected.id, quantity: 1 }] })
            });
            if (!addResponse.ok) throw new Error('Cart error');
            const cartResponse = await fetch(window.SochDostRoutes?.cartJson || '/cart.js');
            const cart = await cartResponse.json();
            document.querySelectorAll('[data-cart-count]').forEach(element => {
              element.textContent = cart.item_count;
              element.hidden = cart.item_count === 0;
            });
            cartButton.textContent = labels.added;
            toast(labels.added);
            window.setTimeout(() => {
              cartButton.disabled = false;
              cartButton.textContent = labels.cart;
            }, 1800);
          } catch (_) {
            cartButton.disabled = false;
            cartButton.textContent = labels.error;
          }
        });
      } catch (_) {
        cartButton.textContent = labels.error;
      }
    };

    const pageLabel = (key, fallback) => {
      const page = document.querySelector('[data-wishlist-page]');
      return page?.dataset[key] || fallback;
    };

    const init = () => {
      enhanceCards(document);
      enhanceProduct();
      sync();
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) enhanceCards(node);
        }));
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    window.SochDostWishlist = { read, write, toggle, sync };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    window.addEventListener('storage', sync);
  })();

  } catch(e) { console.error(e); }
})();
})();
